'use client';
import React, { useEffect } from 'react';
import { WebSiteContext } from '@/useContext/website-context';
import { Website } from '@/types/website';
import Cookies from 'js-cookie';
import cookieMap from '@/config/cookie-map';
import { getCookiePath } from '@/utils/tool';
import { Version } from '@/types/editor';
import useCustomWebsiteStore from '@/store/useCustomWebsiteStore';

interface IProps {
    children: React.ReactNode;
    website: Website;
    pathName: string;
    lang: string;
    adsConfig: any;
}


const ClientMainLayout: React.FC<IProps> = ({ children, website, pathName,lang,adsConfig }) => {
    const userState = Cookies.get(cookieMap.UserState);
    if (!userState) {
        Cookies.set(cookieMap.UserState, JSON.stringify({ siteId: website?.siteId ?? '' }), {
            path: getCookiePath(pathName, lang),
        });
    }else{
        const userStateObj = JSON.parse(userState);
        const userStateObjNew = {
            ...userStateObj,
            siteId: website?.siteId ?? '',
        };
        Cookies.set(cookieMap.UserState, JSON.stringify(userStateObjNew), {
            path: getCookiePath(pathName, lang),
        });
    }

    useEffect(() => {
        const favicon = document.getElementById('favicon');
        if (favicon) {
            favicon.setAttribute('href', website?.logo ?? '');
        }
    }, []);
    console.error('====================ClientMainLayout');
    return (
        <main>
            <WebSiteContext.Provider value={{ params: { siteId: website?.siteId ?? '', name: website?.name ?? '' }, pathName: pathName ,lang:lang,adsConfig:adsConfig }}>{children}</WebSiteContext.Provider>
        </main>
    );
};

export default ClientMainLayout;
